import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { doLogOut, getCurrentUser } from '../Auth';
import './AdminNav.css';

// Admin menu shown at the top of every admin page (/user/...).
// It is added once in Private.js, so every admin page gets it automatically.
function AdminNav() {
  const navigate = useNavigate();
  const user = getCurrentUser() || {};
  const isAdmin = Array.isArray(user.roles) && user.roles.some((r) => r.name === 'ROLE_ADMIN');

  const logOut = () => {
    doLogOut(() => navigate('/login'));
  };

  // NavLink adds the "active" class to the link of the page you are on
  const linkClass = ({ isActive }) => (isActive ? 'admin-nav-link active' : 'admin-nav-link');

  return (
    <nav className="admin-nav" aria-label="Admin menu">
      <div className="admin-nav-inner">
        <span className="admin-nav-title">Admin</span>
        <NavLink to="/user/dashboard" className={linkClass}>Dashboard</NavLink>
        <NavLink to="/user/adddeals" className={linkClass}>Add Deals</NavLink>
        <NavLink to="/user/editdeals" className={linkClass}>Edit Deals</NavLink>
        <NavLink to="/user/addcategory" className={linkClass}>Add Category</NavLink>
        {isAdmin && (
          <>
            <NavLink to="/registration" className={linkClass}>Register User</NavLink>
            <NavLink to="/user/resetpassword" className={linkClass}>Reset Password</NavLink>
          </>
        )}
        <span className="admin-nav-user">
          {user.email}{isAdmin ? ' (ADMIN)' : ''}
          <button type="button" onClick={logOut}>Log out</button>
        </span>
      </div>
    </nav>
  );
}

export default AdminNav;
